import numeral from 'numeral'
import { formatters, dataTypes } from '@adalo/constants'
import { getUserLocale } from './user-locale'

import {
  relativeDate,
  relativeShort,
  absoluteDate,
  absoluteDatetime,
  dayOfWeek,
  timeOnly,
  isoDateOnly,
  isoDateTime,
} from './dates'

export const formatValue = (binding, value, format = {}, helpers = {}) => {
  if (!binding || !binding.source) {
    return ''
  }

  let result = value

  if (value === undefined || value === null || !String(value)) {
    if (
      binding &&
      binding.source &&
      binding.source.dataType === dataTypes.IMAGE
    ) {
      return value
    }

    return ''
  }

  if (helpers.isUploadURL) {
    let { parentSource } = helpers

    let baseURL =
      parentSource && parentSource.dataType === dataTypes.IMAGE
        ? helpers.getImageUploadsBaseURL && helpers.getImageUploadsBaseURL()
        : helpers.getFileUploadsBaseURL && helpers.getFileUploadsBaseURL()

    if (baseURL) {
      return `${baseURL}/${value}?orient`
    }
  }

  switch (binding.source.dataType) {
    case dataTypes.DATE:
      result = formatDate(value, format)
      break
    case dataTypes.DATE_ONLY:
      result = formatDateOnly(value, format)
      break
    case dataTypes.NUMBER:
      result = formatNumber(value, format)
      break
  }

  let prefix = format.prefix
  let suffix = format.suffix

  if (binding.source.dataType === dataTypes.NUMBER && +value === 1) {
    prefix = format.prefixSingular
    suffix = format.suffixSingular
  }

  if (prefix) {
    result = `${prefix} ${result}`
  }
  if (suffix) {
    result = `${result} ${suffix}`
  }

  return result
}

export const formatDate = (dateString, format) => {
  let { type } = format

  switch (type) {
    case formatters.date.RELATIVE:
      return relativeDate(dateString)
    case formatters.date.RELATIVE_SHORT:
      return relativeShort(dateString)
    case formatters.date.ABSOLUTE_DATE:
      return absoluteDate(dateString)
    case formatters.date.ABSOLUTE_DATETIME:
      return absoluteDatetime(dateString)
    case formatters.date.WEEK_DAY_LONG:
      return dayOfWeek(dateString)
    case formatters.date.WEEK_DAY_SHORT:
      return dayOfWeek(dateString, true)
    case formatters.date.TIME:
      return timeOnly(dateString)
    case formatters.date.ISO:
      return isoDateTime(dateString)
    default:
      return dateString
  }
}

export const formatDateOnly = (dateString, format) => {
  let { type } = format

  let justDate = dateString.split('T')[0]
  let dateTime = `${justDate}T00:00:00`

  switch (type) {
    case formatters.dateOnly.RELATIVE:
      return relativeDate(dateTime)
    case formatters.dateOnly.ABSOLUTE_DATE:
      return absoluteDate(dateTime)
    case formatters.dateOnly.WEEK_DAY_LONG:
      return dayOfWeek(dateTime)
    case formatters.dateOnly.WEEK_DAY_SHORT:
      return dayOfWeek(dateTime, true)
    case formatters.dateOnly.ISO:
    default:
      return isoDateOnly(dateString)
  }
}

export const formatNumber = (num, format) => {
  let { type } = format
  const locale = getUserLocale()

  if (Array.isArray(num)) {
    let results = num.map(itm => formatNumber(itm, format))

    if (results.length === 1) {
      return results[0]
    } else {
      return results.join(' - ')
    }
  }

  switch (type) {
    case formatters.number.COMMAS:
      return numeral(num).format('0,0[.][0][0]')
    case formatters.number.ABBREVIATED:
      return numeral(num).format(abbreviatedFormat(num)).toUpperCase()
    case formatters.number.CURRENCY:
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: format.currency || 'usd',
      }).format(num)
    case formatters.number.ABBREVIATED_CURRENCY:
      return numeral(num)
        .format(`$${abbreviatedFormat(num)}`)
        .toUpperCase()
    default:
      return Number(num)
  }
}

export const abbreviatedFormat = num => {
  let order = ((3 * Math.log(num)) / Math.log(1000)) % 3
  let format = '0[.][00]a'

  if (order >= 2) {
    format = '0a'
  } else if (order >= 1) {
    format = '0[.][0]a'
  }

  return format
}
